import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSession } from '../session/useSession';
import { Spinner } from '../ui';

export function RequireAuth({ children }: { children: ReactNode }) {
  const { status } = useSession();
  const location = useLocation();

  if (status === 'loading') {
    return (
      <div className="app-main">
        <Spinner label="Verificando la sesión" />
      </div>
    );
  }

  if (status === 'anonymous') {
    // Se recuerda a dónde iba para volver ahí después de entrar, en vez de dejarlo en el inicio.
    return <Navigate to="/ingresar" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}
